module.exports = __webpack_public_path__ + "img/from-data-to-quanta--niels-bohr-s-vision-of-physics-cover.57c6b0df.jpg";